import React from 'react';

import MaterialsIcons from "../../Icons/MaterialsIcons";

const NewFeatureOverlayComplexLogicStep = (props) => {

  const {complexLogic, onChange} = props;

  return (
    <div className="fc-logic fc-logic--display">
      <div className="fc-logic__header">
        <span className="inline-block">Complex Pricing Logic</span>
      </div>
      <textarea className="ui-code ui-textarea"
                value={complexLogic}
                onChange={onChange}
                title="Leave empty to use standard pricing"/>
      <ul className="fc-logic__legend fix-ul">
        <li className="fc-logic__legend__item">$m  = countertop material</li>
        <li className="fc-logic__legend__item">$b  = backsplash material</li>
        <li className="fc-logic__legend__item">$f  = current feature quanity</li>
        <li className="fc-logic__legend__item">
          $fa = cart items array
          <div className="fc-logic__legend-icon relative">
            {MaterialsIcons.InfoIcon}
            <div className="fc-logic__legend-info">{`[{
  id,
  quantity,
  name,
  sharedFeatureName,
  groupName,
  wizardGroupId,
  currentQuote,
}]`}</div>
          </div>
        </li>
        <li className="fc-logic__legend__item">$c  = current feature cost w/ margin</li>
        <li className="fc-logic__legend__item">$mc = countertop material cost /w margin</li>
        <li className="fc-logic__legend__item">$p  = sssPerQuantity</li>
        <li className="fc-logic__legend__item">{`$room = object with the per room properties {$m, $b, $i}`}</li>
      </ul>
    </div>
  )
};

export default NewFeatureOverlayComplexLogicStep
